import React, { useRef, useEffect } from 'react';
import { useAppContext } from '@/context/AppContext';
import Home from '@/views/home/Home';
import About from '@/views/about/About';
import Projects from '@/views/projects/Projects';
import styles from './App.module.scss';

const App: React.FC = () => {
  const { setScrollContainer } = useAppContext();
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current) {
      setScrollContainer(scrollRef.current);
    }
  }, [setScrollContainer]);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const scrollToHash = () => {
      const { hash } = window.location;
      if (!hash) return;
      const target = document.querySelector(hash) as HTMLElement | null;
      if (target) {
        const top = target.offsetTop;
        container.scrollTop = top;
      }
    };

    const raf = requestAnimationFrame(() => {
      scrollToHash();
      const overlay = document.getElementById('pageTransitionOverlay');
      if (overlay) {
        overlay.style.transition = 'opacity 300ms ease';
        overlay.style.opacity = '0';
        setTimeout(() => overlay.remove(), 320);
      }
    });

    const onHashChange = () => {
      scrollToHash();
    };
    window.addEventListener('hashchange', onHashChange);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('hashchange', onHashChange);
    };
  }, []);

  return (
    <div className={styles.app}>
      <div id="scrollRoot" ref={scrollRef} className={styles.sections}>
        <Home />
        <About />
        <Projects />
      </div>
    </div>
  );
};

App.displayName = 'App';
export default App;
